export default __webpack_public_path__ + "static/media/format.b164d3ce.svg";